import { ITransactionType } from 'types/services';

export const generateTransactionTypeOptions = (transactionTypesData: ITransactionType[]) =>
  transactionTypesData.map((transactionType) => ({
    value: transactionType.id,
    label: transactionType.name,
  }));
